'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Section = require('@quixeltools/quixel-ui-library/dist/components/common/marketing/Section');

var _Section2 = _interopRequireDefault(_Section);

var _Button = require('@quixeltools/quixel-ui-library/dist/components/common/essentials/Button');

var _Button2 = _interopRequireDefault(_Button);

var _glamor = require('glamor');

var _css = require('@quixeltools/quixel-ui-library/dist/utils/css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var container = (0, _glamor.css)({
  display: 'flex',
  justifyContent: 'center',
  textAlign: 'center',
  marginTop: '-2rem',
  '& > h1': {
    paddingBottom: '0.85em'
  },
  '& > span': {
    lineHeight: "1.5em",
    margin: 0
  },
  '& > a': {
    fontSize: '1.125em'
  }
}, (0, _css.minWidth)(_css.breakpoints.xlarge)({
  marginTop: '-2rem'
}), (0, _css.maxWidth)(_css.breakpoints.medium)({
  flexDirection: 'column'
}));

var button = (0, _glamor.css)({
  paddingTop: '0.75em',
  paddingBottom: '0.75em',
  margin: 0,
  '& a': {
    minWidth: '160px'
  }

}, (0, _css.maxWidth)(_css.breakpoints.super4k)({
  paddingTop: '0.75em',
  paddingBottom: '0.75em'
}), (0, _css.maxWidth)(_css.breakpoints.xxxlarge)({
  paddingTop: '0.75em',
  paddingBottom: '0.75em'
}), (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
  paddingTop: '0.75em',
  paddingBottom: '0.75em'
}), (0, _css.maxWidth)(_css.breakpoints.xlarge)({
  paddingTop: '0.75em',
  paddingBottom: '0.75em'
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  paddingTop: '0.75em',
  paddingBottom: '0.75em'

}));

var btnSpacing = (0, _glamor.css)({
  '& span': {
    display: 'block',
    marginLeft: '1.5rem'
  }
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  '& span': {
    marginLeft: '0'
  }
}));

var hr = (0, _glamor.css)({

  border: 'none',
  height: '2px',
  backgroundBlendMode: 'normal, color',
  backgroundImage: 'linear-gradient(-90deg,#2b98f0, #6497bf)',

  display: 'flex',
  width: '8rem',
  justifyContent: 'center',
  margin: 'auto',
  marginBottom: '2.65rem'

}, (0, _css.minWidth)(_css.breakpoints.large)({
  width: '10rem',
  margin: 'auto',
  marginBottom: '2.8rem',
  display: 'block'

}), (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  marginTop: '0',
  marginBottom: '4rem'
}));
var sendUs = (0, _glamor.css)({
  display: 'flex',
  justifyContent: 'center',
  margin: 'auto',
  letterSpacing: '-0.3px',

  marginBottom: '2.8rem',
  fontWeight: '400',
  textAlign: 'center',
  maxWidth: '630px',
  color: '#808080',
  fontSize: '1.6rem',
  lineHeight: 'normal'
}, (0, _css.maxWidth)(_css.breakpoints.large)({
  display: 'flex',
  justifyContent: 'center'
}), (0, _css.maxWidth)(_css.breakpoints.super4k)({
  marginBottom: '3.8rem',
  fontSize: '1.5rem'
}), (0, _css.maxWidth)(_css.breakpoints.xxxlarge)({
  fontSize: '1.4rem'
}), (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
  fontSize: '1.2rem'
}), (0, _css.maxWidth)(_css.breakpoints.xlarge)({
  fontSize: '1.2rem'
}), (0, _css.maxWidth)(_css.breakpoints.large)({
  fontSize: '1.125rem'
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  fontSize: '1rem'
}));
var sectionContainer = (0, _glamor.css)({
  padding: 0
});
var section = (0, _glamor.css)({
  minHeight: '480px',
  paddingTop: '9rem'
});

var ContactSection = function (_React$Component) {
  (0, _inherits3.default)(ContactSection, _React$Component);

  function ContactSection(props) {
    (0, _classCallCheck3.default)(this, ContactSection);
    return (0, _possibleConstructorReturn3.default)(this, (ContactSection.__proto__ || (0, _getPrototypeOf2.default)(ContactSection)).call(this, props));
  }

  (0, _createClass3.default)(ContactSection, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      return _react2.default.createElement(_Section2.default, {
        className: sectionContainer,
        innerClassName: section,
        mode: props.mode,
        title: props.title //?'Don’t see a plan that fits your needs?'
        , subHeading: props.subHeading //"GET IN TOUCH"
        , subTitle: props.subTitle,
        content: _react2.default.createElement(
          'div',
          { className: container },
          props.primaryLabel && _react2.default.createElement(_Button2.default, {
            small: true,
            label: props.primaryLabel,
            className: button,
            to: props.primaryTo,
            onClick: props.onClickPrimaryHandler,
            mode: 'secondary'
          }),
          props.secondaryLabel && _react2.default.createElement(_Button2.default, {
            small: true,
            label: props.secondaryLabel,
            className: (0, _glamor.css)(button, btnSpacing),
            to: props.secondaryTo,
            onClick: props.onClickSecondaryHandler,
            mode: 'secondary'
          })
        )
      });
    }
  }]);
  return ContactSection;
}(_react2.default.Component);

exports.default = ContactSection;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactSection/ContactSection.jsx
// module id = 2725
// module chunks = 0